import { css } from '@emotion/react'
import { SpacingToken, Text } from '@livechat/design-system-react-components'

import VotesDistribution from '@/components/Product/Reviews/VotesDistribution'
import RatingInfo from '@/components/Product/Reviews/RatingInfo'
import mediaQueries from '@/layout/media-queries'
import { getMarketplaceTermsLink } from '@/utils/products'
import { getProductFeedbackSummary, getItemById } from '@/store/selectors'
import { type FeedbackSummary } from '@/interfaces/feedback'
import useParamSelector from '@/hooks/useParamSelector'
import { useTypedSelector } from '@/store/hooks'
import theme from '@/theme'
import Review from './Review'

const reviewsInfo = css`
  margin: var(${SpacingToken.Spacing5}) 0;
`

const ratingInfoCss = css`
  > span:last-of-type {
    line-height: 13px;
  }
`

const ratingSummary = css`
  display: flex;
  flex-direction: column;

  > div,
  > p {
    width: 100%;
  }

  > div {
    margin-left: 0;
    margin-right: 0;
  }

  ${mediaQueries.xsmallScreen(60)} {
    flex-direction: row;

    > div,
    > p {
      width: 50%;
    }
  }
`

interface Props {
  id: string
}

const ReviewsModal = ({ id }: Props) => {
  const productName = useParamSelector(getItemById, id)?.name || 'application'
  const { reviews, histogram, rate, votes }: FeedbackSummary = useTypedSelector(
    getProductFeedbackSummary
  )

  return (
    <>
      <div css={ratingSummary}>
        <RatingInfo rate={rate} votes={votes} css={ratingInfoCss} />
        <VotesDistribution
          histogram={histogram}
          fullWidth
          color={theme.colors.yellow}
        />
      </div>

      <Text css={reviewsInfo}>
        All ratings and reviews were added by actual {productName} users.{' '}
        {process.env.GATSBY_PRODUCT_LABEL} customer first have to install the
        app, after that is able to leave a review. Opinions are submitted
        voluntarily and are moderated in terms of violation{' '}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={getMarketplaceTermsLink()} target="_blank" rel="noopener">
          terms of service
        </a>
        , including spam.
      </Text>

      {reviews?.map(({ createdAt, name, text, rate }) => (
        <Review key={createdAt + name} name={name} text={text} rate={rate} />
      ))}
    </>
  )
}

export default ReviewsModal
